/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-listing-card[_ngcontent-%COMP%]{width:100%;margin-bottom:10px}.more-listings-separator[_ngcontent-%COMP%]{text-align:center;font-size:2.5rem;font-weight:700}@media (min-width:600px){app-listing-card[_ngcontent-%COMP%]{width:48%;margin:1%}}@media (min-width:900px){app-listing-card[_ngcontent-%COMP%]{width:32%;margin:1% .66%}}@media (min-width:1200px){app-listing-card[_ngcontent-%COMP%]{width:23%;margin:1%}}@media (max-width:1199px){[_nghost-%COMP%]{background-color:#fff}}"];
export { styles as styles };
